<div class="common">
  <div class="textContent" *ngIf="contentType === 'TextContent'">
    <ft-text-content
      [document]="document"
      [content]="content"
      [page]="page"
    ></ft-text-content>
  </div>
</div>
